import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { DEPRECATED_QUERY_KEYS, QUERY_KEYS } from '@src/query';
import { ProductView, ApiTypes } from 'common';
import { getProducts, getProductsAvailablesLocalizations } from './api';

export const useQueryProducts = (productIds: string[], config?: Omit<UseQueryOptions<ProductView[]>, 'queryKey' | 'queryFn'>) => useQuery<ProductView[]>({
  queryKey: [DEPRECATED_QUERY_KEYS.PRODUCT, productIds],
  queryFn: async (): Promise<ProductView[]> => {
    if (!productIds.length) {
      return [];
    }
    const products = await getProducts({
      ids: productIds,
    });
    return products;
  },
  ...config,
});

export const useQueryAllProducts = (config?: UseQueryOptions<ProductView[]>) =>
    useQuery<ProductView[]>({
      queryKey: [DEPRECATED_QUERY_KEYS.PRODUCT],
      queryFn: async (): Promise<ProductView[]> => {
        const products = await getProducts({});
        return products;
      },
      ...config,
    });

export const useQueryProductsAvailableCountries = () => useQuery<ApiTypes.ResGetLocalizationMappings>({
  queryKey: [QUERY_KEYS.productsAvailableLocalizations],
  queryFn: async (): Promise<ApiTypes.ResGetLocalizationMappings> => {
    return getProductsAvailablesLocalizations();
  },
});
